export default {
    data() {
        return {
            footerLink: [
                { 
                    text: this.$t('FooterCompanyText'),
                    url: this.$t('FooterCompanyUrl'),
                    title: this.$t('FooterCompanyTitleAttribute')
                },
                { 
                    text: this.$t('FooterContactText'),
                    url: this.$t('FooterContactUrl'),
                    title: this.$t('FooterContactTitleAttribute')
                },
                { 
                    text: this.$t('FooterPrivacyPolicyText'),
                    url: this.$t('FooterPrivacyPolicyUrl'),
                    title: this.$t('FooterPrivacyPolicyTitleAttribute')
                },
                { 
                    text: this.$t('FooterTermsOfUseText'),
                    url: this.$t('FooterTermsOfUseUrl'),
                    title: this.$t('FooterTermsOfUseTitleAttribute')
                },
            ]
        };
    },
};



// WEBPACK FOOTER //
// ./src/components/CCPAFooter/CCPAFooter.js